export const NOME_EMPRESA = "Laus Pizza"; // NOME PRINCIPAL DA LOJA

export const CNPJ = "14567047000147"; // CNPJ DA EMPRESA QUE CONDIZ COM TRADE TOUCH

export const PRECO_ATACADO = false; // SE TRUE PRECO DE VENDA VIRA O O PRECO DE ATACADO

export const VIEW_GRUPO2 = false; // set true sepera por grupo2 e mostra subdivicoes do grupo1

export const RECEITA_CHEIA = true;

export const FATIA_PIZZA = true;

export const Colors = {
    backgroundColorApp : '#FFF',
    backgroundHeader: '#482f1f',
    loadingColor: '#482f1f',
    icon: '#FFF',
    header: '#482f1f',
    headerCircleColor: 'rgba(0,0,0,0)',
    headerBorderColors: '#482f1f',
    inputHeaderBackgroundColor: '#FFF',
    inputHeaderTextColor: '#482f1f',
    inputHeaderPlaceHolderColor: '#c9c9c9',
    groupBackgroundColor: '#482f1f',
    groupColorText: '#FFF',
    groupBackgroundColorNv2: '#44301c',
    groupColorTextNv2: '#FFF',
    ScrollNv2: '#44301c',
    prodBackgroundColor: '#482f1f',
    prodBorderColor: '#482f1f',
    prodTextColor: '#FFF',
    modalBackgroundColor: '#482f1f',
    modalTitleColor: '#FFF',
    modalObsColor: '#FFF',
    modalDetailColor: '#FFF',
    listGroupTitleColor: '#FFF',
    listGroupBackground: '#482f1f',
    listGroupBorderColor: '#482f1f',
}
